<template>
  <el-dialog width="60%" top="0vh" title="选择节目" @closed="dialogVisible(false)" :visible.sync="visible" append-to-body
    destroy-on-close>
    <div class="play-list">
      <subfield>
        <template slot="list">
          <trees :title="$t('cspm1')" type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
        </template>
        <template slot="content">
          <enfold-cd>
            <template slot="center">
              <el-table highlight-current-row ref="multipleTable" :data="programList" style="width: 100%" height="100%"
                @row-click="tableRowClick">
                <el-table-column :label="$t('schedule.Screenshot')" width="120">
                  <template slot-scope="scope">
                    <div class="operation">
                      <img style="width: 96px; height: 54px;" v-if="scope.row.damaged === 0" :src="scope.row.pimg"
                        alt />
                      <img style="width: 96px; height: 54px;" v-else src="@imgpub/damaged.png" alt />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('schedule.ProgramName')"></el-table-column>
                <el-table-column prop="size_remark" :label="$t('schedule.Resolution')"></el-table-column>
                <el-table-column prop="group_name" :label="$t('schedule.Structure')"></el-table-column>
                <el-table-column prop="play_time" :label="$t('cbu7')">
                  <template slot-scope="scope">
                    {{ scope.row.play_time | playTime }}
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <template slot="down">
              <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
            </template>
          </enfold-cd>
        </template>
      </subfield>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible(false)">取 消</el-button>
      <el-button type="primary" @click="dialogVisible(true)" :disabled="!this.program">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import EnfoldCd from "@/components/basics/EnfoldCD"
import trees from '@/components/basics/Trees'
import pagination from '@/components/basics/Pagination'
import { mPagination } from "@/components/basics/mixins";
import { msFormatting } from "@/assets/scripts/dateFormatting.js";
export default {
  name: "AddPoint",
  mixins: [mPagination],
  props: {
    innerVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    subfield,
    EnfoldCd,
    pagination,
    trees
  },
  data() {
    return {
      groupList: [],
      programList: [],
      program: null,
      visible: false
    }
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.getProgramList();
  },
  mounted() {
  },
  methods: {
    getAssets(ids) {
      if (ids.type === "GROUP") {
        this.groupId = ids.id;
        this.groupIds = ids.ids;
        this.page = 1;
        this.current = 0;
        this.programList = [];
      }
      this.getProgramList();
    },
    getProgramList() {
      this.$http.post('/admin/play/list', {
        group_ids: this.groupIds,
        limit: this.limit,
        page: this.page
      }, data => {
        this.current = data.count ? parseInt(data.count) : 0;
        this.programList = data.list;
      })
    },
    tableRowClick(row) {
      this.program = row;
      this.$refs.multipleTable.setCurrentRow(row);
    },
    currentChange(val) {
      this.page = val;
      this.getProgramList();
    },
    dialogVisible(bool) {
      this.visible = false;
      this.$emit('closeDialog', bool, this.program);
      this.program = null;
    },
  },
  filters: {
    playTime(value) {
      return value ? msFormatting(value) : "--:--:--";
    }
  },
  watch: {
    innerVisible() {
      this.visible = this.innerVisible;
    }
  }
}
</script>

<style lang="scss" scoped>
.play-list {
  width: 100%;
  height: 500px;
}

.subfield {
  padding: 0px;
  width: 100%;
  height: 100%;
}

/deep/ .el-dialog {
  margin: 0px;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .el-dialog__header {
  padding: 16px;
  border-radius: 8px 8px 0px 0px;
  // background-image: linear-gradient(270deg,
  //     #86eae7 0%,
  //     #4cccf0 45%,
  //     #11adf8 100%),
  //   linear-gradient(#ffffff, #ffffff);
  // background-blend-mode: normal, normal;
  background-color: var(--theme-color-customized-1);

  .el-dialog__title {
    font-size: 20px;
    color: #fff;
  }
}

/deep/ .el-dialog__body {
  padding: 16px 16px 0px 16px;
  overflow: hidden;
}

/deep/ .el-dialog__footer {
  padding: 0px 16px 16px;
  border-radius: 0px 0px 8px 8px;

  /deep/ .el-button+.el-button {
    margin-left: 20px;
  }
}
</style>